import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col, DropdownItem, DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  Table, UncontrolledButtonDropdown
} from "reactstrap"
import { NIL } from "uuid"
import DatePicker from "react-datepicker"
import { getMaxValue } from "../../helpers/utils"
import ProductStockInRow from "./ProductStockInRow"
import moment from "moment/moment"
import ProductStockInConfirmModal from "./ProductStockInConfirmModal"
import PrintPreviewModal from "./PrintPreviewModal"
import WarehouseSelect from "../warehouse/WarehouseSelect";
import ProductSelect from "../product/ProductSelect";

const ProductStockInForm = props => {
  const { item, onSubmit, onCancel } = props
  const [ isHeaderSelected, setIsHeaderSelected ] = useState(false)
  const [ modalConfirmStock, setModalConfirmStock ] = useState(false)
  const [ modalPrintPreview, setModalPrintPreview ] = useState(false)

  const [ productStockIn, setProductStockIn ] = useState({
    id: NIL,
    code: '',
    name: '',
    status: 0,
    warehouseId: null,
    date: new Date(),
    productStockInProducts: []
  })

  const [ isSubmitted, setIsSubmitted ] = useState(false)
  

  useEffect(() => {
    if (item) {
      setProductStockIn({
        ...item,
        date: moment(item.date).toDate(),
        warehouseId: item.warehouseId ? {
          id: item.warehouseId,
          value: item.warehouseId,
          label: item.warehouseName
        } : null,
        productStockInProducts: item.productStockInProducts ? item.productStockInProducts.map((a, index) => {
          return {
            ...a,
            index,
            label: `${ a.productCode } - ${ a.productName }`,
            productId: {
              key: a.productId,
              value: a.productId,
            },
            locationId: a.locationId ? {
              key: a.locationId,
              value: a.locationId,
              label: a.locationName
            } : null,

            unitOfMeasurementId: {
              key: a.unitOfMeasurementId,
              value: a.unitOfMeasurementId,
              label: a.unitOfMeasurementName
            }
          }
        }) : [],
      })

    } else {
      setProductStockIn({
        id: NIL,
        code: '',
        name: '',
        date: new Date(),
        status: 0,
        warehouseId: null,
        productStockInProducts: []
      })
    }
  }, [ item ])
  
  
  const handleOnSelectProduct =(product) =>{
    let max = 0;
    
    if (productStockIn.productStockInProducts.length > 0) {
      max = getMaxValue(productStockIn.productStockInProducts.map(a => a.index));
      max += 1;
    } else {
      max = max + 1;
    }
    let newEntry={
      ...product,
      index: max,
    }
    
    setProductStockIn({ ...productStockIn, productStockInProducts: [...productStockIn.productStockInProducts, newEntry] }); 
  }

  const handleDeleteSelected = () => {
    setProductStockIn({
      ...productStockIn,
      productStockInProducts: productStockIn.productStockInProducts.filter(e => !e.isSelected)
    })
    setIsHeaderSelected(false)
  }

  const handleHeaderSelect = e => {
    const { checked } = e.target
    setIsHeaderSelected(checked)
    setProductStockIn({
      ...productStockIn,
      productStockInProducts: productStockIn.productStockInProducts.map(entry => {
        return {
          ...entry,
          isSelected: checked
        }
      })
    })
  }

  const handleStockInItemChange = entry => {
    setProductStockIn({
      ...productStockIn,
      productStockInProducts: productStockIn.productStockInProducts.map(a => a.index === entry.index ? entry : a)
    })
  }

  const handleDeleteStockInItem = (entry) => {
    setProductStockIn({
      ...productStockIn,
      productStockInProducts: productStockIn.productStockInProducts.filter(e => e.index !== entry.index)
    })
  }

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setProductStockIn({
      ...productStockIn,
      [name]: value
    })
  }

  const handleOnDateChange = (name, value) => {
    setProductStockIn({
      ...productStockIn,
      [name]: value
    })
  }

  const handleSubmit = () => {
    setIsSubmitted(true)
    let isValid = productStockIn.warehouseId && productStockIn.date && productStockIn.name
    let hasNull = productStockIn.productStockInProducts.some(e => !e.unitOfMeasurementId || e.quantity === 0)


    if (!hasNull && isValid) {
      let data = {
        ...productStockIn,
        warehouseId: productStockIn.warehouseId?.value,
        date: productStockIn.date?.toISOString(),
        productStockInProducts: productStockIn.productStockInProducts.map(entry => {
          return {
            ...entry,
            productId: entry.productId?.value,
            locationId: entry.locationId?.value,
            unitOfMeasurementId: entry.unitOfMeasurementId?.value
          }
        })
      }

      onSubmit(data)
    }
  }

  const handleSubmitStockConfirmation = () => {
    setModalConfirmStock(false)
    setIsSubmitted(true)
    let isValid = productStockIn.warehouseId && productStockIn.date && productStockIn.name
    let hasNull = productStockIn.productStockInProducts.some(e => !e.unitOfMeasurementId || e.quantity === 0)


    if (!hasNull && isValid && productStockIn.productStockInProducts.length > 0) {
      let data = {
        ...productStockIn,
        warehouseId: productStockIn.warehouseId?.value,
        status: 1,
        date: productStockIn.date?.toISOString(),
        productStockInProducts: productStockIn.productStockInProducts.map(entry => {
          return {
            ...entry,
            productId: entry.productId?.value,
            locationId: entry.locationId?.value,
            unitOfMeasurementId: entry.unitOfMeasurementId?.value
          }
        })
      }

      onSubmit(data)
    }
  }


  return (
      <>
        <Card className={ "mb-2" }>
          <CardHeader className={ "bg-transparent border-bottom" }>
            <Row>
              <Col>
                <CardTitle>Info</CardTitle>
              </Col>
              <Col className={ "text-end" }>
                {
                  productStockIn.id !== NIL ?
                      <UncontrolledButtonDropdown>
                        <DropdownToggle caret color="primary" outline>
                          <i className="mdi mdi-dots-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          <DropdownItem
                              onClick={ () => setModalPrintPreview(true) }
                              className="text-primary"
                          >
                            <i className="mdi mdi-printer me-1"/> Print Preview
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledButtonDropdown> : null
                }
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Row>
              <Col>
                <div className="mb-3">
                  <div
                      className={
                          "select2-container" +
                          (isSubmitted && !productStockIn.warehouseId ? " is-invalid" : "")
                      }
                  >
                    
                  <Label htmlFor="">Warehouse</Label>
                  <WarehouseSelect value={ productStockIn.warehouseId } onChange={ option => {
                    setProductStockIn({
                      ...productStockIn,
                      warehouseId: option
                    })
                  } }/>
                  </div>
                  { isSubmitted && !productStockIn.warehouseId && (
                      <div className="invalid-feedback-custom">
                        Warehouse is required.
                      </div>
                  ) }
                </div>
                <FormGroup className="mb-3">
                  <Label htmlFor="">Code</Label>
                  <Input
                      type="text"
                      name="code"
                      placeholder="Auto Generate"
                      value={ productStockIn.code }
                      readOnly
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="">Title</Label>
                  <Input
                      type="text"
                      name="name"
                      placeholder="Title"
                      autoComplete="off"
                      className={ isSubmitted && !productStockIn.name ? "is-invalid" : "" }
                      value={ productStockIn.name }
                      onChange={ handleOnChange }
                  />
                  { isSubmitted && !productStockIn.name && (
                      <div className="invalid-feedback-custom">Name is required.</div>
                  ) }
                </FormGroup>
              </Col>
              <Col>
                <FormGroup
                    className={
                        "select2-container" + (isSubmitted && !productStockIn.date ? " is-invalid" : "")
                    }
                >
                  <Label>Stock In Date</Label>
                  <DatePicker
                      className="form-control"
                      selectsStart
                      name="date"
                      selected={ productStockIn.date }
                      onChange={ obj => handleOnDateChange('date', obj) }
                      dateFormat="dd-MMM-yyyy"
                      placeholderText="Stock In Date"
                      isClearable
                  />
                </FormGroup>
                { isSubmitted && !productStockIn.date && (
                    <div className="invalid-feedback-custom">
                      Stock In Date is required.
                    </div>
                ) }
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card className={ "mb-2" }>
          <CardHeader className={ "bg-transparent border-bottom" }>
            <Row>
              <Col md={ 2 }>
                <CardTitle className={ "pt-2" }>Items</CardTitle>
              </Col>
              <Col>
              </Col>
            </Row>
          </CardHeader>
          <CardHeader className={ "bg-transparent border-bottom" }>
            <Row>
              <Col>
                <Label className={ "mt-2" }>Find Items:</Label>
              </Col>
              <Col md={ 8 }>
                <ProductSelect 
                    name="productId"
                    warehouseId={productStockIn.warehouseId?.value}
                    placeholder={"Find by Code, Name, ..." } 
                    onSelect={handleOnSelectProduct}/>
              </Col>
              <Col>
                <div className="text-sm-end">
                  <Button color={ "danger" }
                          onClick={ handleDeleteSelected }
                          outline
                          disabled={ !productStockIn.productStockInProducts.some(e => e.isSelected) }
                  >
                    <i className="fas fa-trash me-1"/> Delete Selected
                  </Button>
                </div>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Table
                id="tech-companies-1"
                className="table-editable table table-striped table-bordered table-nowrap"
            >
              <thead className={ "bg-primary text-white" }>
              <tr>
                <th className={ "text-center" } style={ { width: "80px" } }>
                  <input
                      type="checkbox"
                      className="form-check-input"
                      id="headerSelected"
                      checked={ isHeaderSelected }
                      onChange={ handleHeaderSelect }
                  />
                </th>
                <th className="text-center">Item</th>
                <th className={ "text-center" } style={ { width: "250px" } }>Quantity</th>
                <th className={ "text-center" } style={ { width: "250px" } }>UOM</th>
                <th className={ "text-center" } style={ { width: "250px" } }>Location</th>
                <th className={ "text-center" } style={ { width: "120px" } }>Action</th>
              </tr>
              </thead>
              <tbody>

              {
                productStockIn.productStockInProducts.map((entry, index) => {
                  return <ProductStockInRow
                      key={ index }
                      item={ entry }
                      isSubmitted={ isSubmitted }
                      onChange={ handleStockInItemChange }
                      onDelete={ handleDeleteStockInItem }
                  />
                })
              }
              </tbody>
            </Table>
          </CardBody>
        </Card>

        <Card className={ "mb-2" }>
          <CardBody>
            {
                [ 0 ].includes(productStockIn.status) && // Draft
                <Button color="primary" className={ "me-1" }
                        onClick={ handleSubmit }
                        type="submit">
                  Submit
                </Button>
            }
            {
                productStockIn.id !== NIL && [ 0 ].includes(productStockIn.status) && productStockIn.productStockInProducts.length > 0 && // Draft
                <Button color="primary" className={ "me-1" }
                        onClick={ () => setModalConfirmStock(true) }
                        type="submit">
                  Confirm Into Stock
                </Button>
            }

            <Button color="secondary"
                    onClick={ () => onCancel() }
                    type="button">
              Cancel
            </Button>
          </CardBody>
        </Card>

        <ProductStockInConfirmModal
            title="Confirm item into stock"
            isOpen={ modalConfirmStock }
            toggle={ () => setModalConfirmStock(!modalConfirmStock) }
            onSubmit={ handleSubmitStockConfirmation }
        />

        <PrintPreviewModal
            isOpen={ modalPrintPreview }
            productStockInId={ productStockIn.id }
            toggle={ () => setModalPrintPreview(!modalPrintPreview) }
        />
      </>
  )
}

ProductStockInForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  item: PropTypes.object,
}

export default ProductStockInForm